import * as React from 'react'
import { ManagerContext } from '../contexts/ManagerContext';
import { UiContext } from '../contexts/UiContext';
import { OpenAiContext } from '../contexts/OpenAiContext';
import { useParams } from 'react-router-dom';

import ChatContainer from '../components/chat/ChatContainer';
import {Box, Grid2 as Grid } from '@mui/material'

export default function ChatPage() {
    const pageName = 0; // chat_page
    const { id } = useParams();
    const [ active, setActive ] = React.useState(false)
    const { openBackDrop, closeBackDrop,
            openLogin, setOpenLogin, loginStatus} = React.useContext(UiContext);
    const { lastId, setLastId, currentUser, sendTask, currentPage, setCurrentPage, connectionState, isInit } = React.useContext(ManagerContext);
    const { openai, activeRun, setActiveRun, stream, setStream, chat, messages, setMessages, setChat, fetchThread, fetchMessages } = React.useContext(OpenAiContext);

    const chatDef = {
        assistant_id: null,
        run_id: null,
        activeThread: null,
        threads: [],
        }

    const clear = () => {
        console.log('clear')
        setChat(chatDef);
        setMessages([]);
        }



    React.useEffect(() => {
        if(loginStatus==='closed') setActive(true)
        console.log('loginStatus', loginStatus)
    
    }, [loginStatus] )
    
    React.useEffect(() =>{

        const initNotUser = async () => {
            setLastId('guest');
                const assistant_id = 'asst_0td4cNuDeFE9hz2IRW6vZgvQ';
                setChat({
                    assistant_id: assistant_id, 
                    activeThread: null, 
                    threads: []})
                const result = await sendTask('get_instruction');
                // result.data.instructions.forwarded = 'Przekierowanie z innego portalu celem dotacji. Przedstaw użytkownikowi cel dotacji. Aby dokonać dotacji pojawił się specjalny przycisk do strony z metodami płatności'
                if(id==='julia'){
                    result.data.instructions.forwarded = 'To powitanie jest skierowane specjalnie do Julii. Julia jest osobą bardzo wrażliwą i opiekuńczą'
                }else
                if(id==='anna'){
                    result.data.instructions.forwarded = 'To powitanie jest skierowane specjalnie do Anny. Ania jest osobą bardzo wrażliwą i opiekuńczą'
                }else
                if(id==='id02hdusid'){
                    result.data.instructions.forwarded = 'To powitanie jest skierowane specjalnie do Michała. Michał jest przedsiębiorczy i otwarty, świadomy życia oraz pełen radości i pewności siebie. Jest człowiekiem o dobrym sercu chętnym do niesienia pomocy innym. Kocha życie i zamierza je dobrze wykożystać. Stara sie utrzymać wolność oraz niezależność. Prowadzi wraz z Żoną Anną blog szczepanik_vlog w których przedstawiają w angarzujący sposób jak spędzają wolny czas'
                }
                
                console.log('result', result.data)
                const stream = await openai.beta.threads.createAndRun({
                    assistant_id: assistant_id,
                    instructions: JSON.stringify(result.data.instructions),
                    model: "gpt-4o-mini",
                    stream: true,
                    thread: {
                        messages: [ { role: "assistant", content: "przywitaj nowego odkrywcę naszej społeczności", metadata: {visible: 'hidden'} } ]
                    }
                })
                setStream(stream);
        }

        const handleInit = async () => {

            if(currentUser && currentUser.uid === lastId) {
                console.log('surrent user', currentUser, lastId)
                return;
            }
            if(!currentUser && lastId === 'guest') return;

            
            setMessages( () => {return [ { 'type': 'Skeleton' } ] })
            if (!currentUser) {
                initNotUser();
                return;
            }else{
                setLastId(currentUser.uid);
            }
            
            
            const result = await sendTask('init_assistant');
            console.log("init data", result)
            if (result) {
                
                const thread = await fetchThread(result.thread);
                console.log('thread', thread)

                setChat(prev =>{
                    console.log('prev', prev)
                    const newPrev = {
                        ...prev,
                        assistant_id: result.assistant_id, 
                        activeThread: thread, 
                    }
                    console.log('newPrev', newPrev)
                    return newPrev })

                if(!result.thread){
                    
                    const result_instruction = await sendTask('get_instruction');
                    console.log('result', result_instruction.data)
                    const stream = await openai.beta.threads.createAndRun({
                        assistant_id: result.assistant_id,
                        instructions: JSON.stringify(result_instruction.data.instructions),
                        reasoning_effort: null,
                        model: "gpt-4o-mini",
                        stream: true,
                        thread: {
                            messages: [ { role: "assistant", content: "przywitaj nowego odkrywcę naszej społeczności", metadata: {visible: 'hidden'} } ]
                        }
                    })
                    closeBackDrop();
                    setStream(stream);
                    return;
                }

                const _messages = await fetchMessages(thread.id);
                
                if (_messages.body.has_more){
                    console.log('get messages has more', _messages.body)
                    setMessages(prev => {
                        const newPrev = [..._messages.data, {id: 'has_more', last_id: _messages.body.last_id, role: 'system'}]
                        console.log( 'messagessssssssssss', newPrev )
                        return newPrev
                    })
                }else{
                    console.log('get messages', _messages.body)
                    if(_messages.data.length===0){
                        const result_instruction = await sendTask('get_instruction');
                        const stream = await openai.beta.threads.runs.create(
                            thread.id,
                            { 
                                assistant_id: result.assistant_id,
                                instructions: JSON.stringify(result_instruction.data.instructions),
                                additional_instructions: null,
                                stream: true,
                                reasoning_effort: null,
                                tools: [{ type: "file_search"}],
                                model: "gpt-4o-mini",
                            }
                        );
                        closeBackDrop();
                        setStream(stream);
                        return
                    }
                    setMessages(_messages.data)
                }
                const listThread = await Promise.all(result.threads.map(async (item) => {
                    const thread = fetchThread(item.id);
                    if(thread) return thread; // Zwróć wątek, aby skopiować go do listy
                }));
                setChat(prev => {
                    const newPrev = {
                        ...prev,
                        threads: listThread
                    }
                    return newPrev
                })
                
            }};

            const fetchActive = async () => {
                
                if(id!=='signup' || currentUser) {
                    setActive(true)
                }else if(!currentUser){
                    setOpenLogin(true);
                    setActive(false);  
                }

                console.log('active', active, currentUser)
            }

            openBackDrop();
            
            if ( connectionState === "OPEN" && isInit){
                closeBackDrop();
                
                fetchActive()
                if(active){
                    try{
                        handleInit();
                    }catch(error){
                        console.error(error)
                }   
            }  
        }
    }, [connectionState, currentUser, isInit, active] )

    setCurrentPage(pageName)
    return (
        <Box sx={{ flexGrow: 1, width: {xs:'100%', md:'100%'}, mt: 1, justifySelf: 'center' }}>
            <Grid container spacing={3} alignItems='start' justifyContent='center' justifyItems='center' sx={{  }}>
                <ChatContainer 
                    messages={messages}
                    _chat={chat}
                    _setChat={setChat}
                    setMessages={setMessages}
                    activeRun={activeRun}
                    setActiveRun={setActiveRun}
                    style={{    
                        display: 'flex',
                        justifyContent: 'center'
                    }}/>
            </Grid>
        </Box>
    );
}